import React, { useState } from 'react';
import "./styles.css";
import { Button, Switch, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import { BiMessageAdd } from "react-icons/bi";
import 'react-phone-input-2/lib/style.css'
import PhoneInput from 'react-phone-input-2'

import addSupplier from 'utils/addSupplier';
import Cookies from 'js-cookie';

const TopBarFilter = ({ onOnlyVendors, onFilterChange, data }) => {
  const [filter, setFilter] = useState('all');
  const [onlyVendors, setOnlyVendors] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [name, setName] = useState('');
  // const [filteredData, setFilteredData] = useState(data);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    onFilterChange(newFilter);
  };

  const handleVendorFilterToggle = (event) => {
    console.log('event.target.checked',event.target.checked)
    setOnlyVendors(event.target.checked);
    onOnlyVendors(event.target.checked);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };


  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleContactSave = () => {
    addContact(phoneNumber, name);
    setPhoneNumber('');
    setName('');
    handleDialogClose();
  };

  const addContact = async (phoneNumber,name) => {
    // implement the function to add the contact here
    console.log(phoneNumber, name);
    let token = await getToken();
    console.log('Token found for addContact: ' + token)
    if(token)
      await addSupplier(token, phoneNumber, name);
    else
      console.error('addContact:Could not get token');
  };

  const getToken = async () => {
		const token = Cookies.get('_auth');
		// console.log('getToken', token);
		return token;
	}


  const filterCount = (status) => {

    if (!data || data.length === 0) {
      return 0;
    }
    
    let filteredData = data.filter(obj => obj.botStatus === status);
    
    if (onlyVendors) {
      filteredData = filteredData.filter(obj => obj.provider === onlyVendors);
    }else{
      filteredData = filteredData.filter(obj => obj.provider !== true);
    }
    
    return filteredData.length;    

  };


  return (
    <Box className="top-bar-filter" sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {/* Vendor filter */}
      <Box className="vendor-filter" sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <label style={{ 
        fontWeight: onlyVendors ? "normal" : "bold",
        color: onlyVendors ? "black" : "blue"
         }}>לקוחות</label>
      <Switch 
        checked={onlyVendors} 
        onChange={handleVendorFilterToggle} 
        name="vendor-filter-switch" 
        inputProps={{ 'aria-label': 'Filter vendors' }} 
      />
      <label style={{ 
        fontWeight: onlyVendors ? "bold" : "normal",
        color: onlyVendors ? "blue" : "black"
         }}>ספקים</label>
      {onlyVendors && <BiMessageAdd size={20} onClick={handleDialogOpen} />}
    </Box>
      {/* Add Contact Dialog */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle sx={{ textAlign:"center" }}>הוסף ספק</DialogTitle>
        <DialogContent>

        <PhoneInput
            country={'auto'}
            value={phoneNumber}
            label="מספר טלפון"
            onChange={handlePhoneNumberChange}
            inputProps={{
              autoFocus: true,
              style: { textAlign: 'right', width: '100%' },
            }}
            inputStyle={{
              width: '100%',
            }}
            containerStyle={{
              width: '100%',
            }}
          />


        <TextField
            margin="dense"
            label="שם"
            type="text"
            fullWidth
            value={name}
            onChange={handleNameChange}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>ביטול</Button>
          <Button onClick={handleContactSave}>שמירה</Button>
        </DialogActions>
      </Dialog>
      {/* Buttons */}
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
        <Button 
          variant={filter === 'all' ? 'contained' : 'disableElevation'} 
          disabled={filter === 'all'}
          onClick={() => handleFilterChange('all')}
        >
          All({filterCount(null)})
        </Button>

        <Button 
          variant={filter === 'open' ? 'contained' : 'disableElevation'}
          disabled={filter === 'open'}
          onClick={() => handleFilterChange('open')}
        >
          Open({filterCount(1)})
        </Button>

        <Button 
          variant={filter === 'pending' ? 'contained' : 'disableElevation'}
          disabled={filter === 'pending'}
          onClick={() => handleFilterChange('pending')}
        >
          Pending({filterCount(2)})
        </Button>

        <Button 
          variant={filter === 'closed' ? 'contained' : 'disableElevation'}
          disabled={filter === 'closed'}
          onClick={() => handleFilterChange('closed')}
        >
          Closed({filterCount(3)})
        </Button>

      </Box>
    </Box>
  );
};

export default TopBarFilter;
